<script setup lang="ts">
import ActionSource from "@/components/action/ActionSource.vue";
</script>

<template>
  <ActionSource value="attribute-chip" class="sticky-note-row">
    <slot />
  </ActionSource>
</template>

<style lang="scss" scoped>
.sticky-note-row {
  display: flex;
  height: 20px;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;

  :deep(> *) {
    min-width: 0;
  }
}
</style>
